import { useEffect, useState } from 'react';
import { getForecast, weatherIcon, type DayForecast } from '@/lib/api/weather';

// 14-day site-weather strip for the calendar — flags days that threaten
// pours/roofing (amber = caution, red = high risk). Region: Duncan/Cowichan.
export function WeatherStrip() {
  const [days, setDays] = useState<DayForecast[]>([]);
  useEffect(() => { getForecast().then(setDays).catch(() => {}); }, []);
  if (!days.length) return null;
  return (
    <div className="flex items-center gap-1 overflow-x-auto scrollbar-none px-2 py-1 bg-white border-b border-gray-100">
      <span className="text-[9px] font-bold uppercase tracking-widest text-gray-400 pr-1 flex-shrink-0">Weather</span>
      {days.map(d => (
        <div
          key={d.date}
          title={`${new Date(d.date + 'T12:00:00').toLocaleDateString('en-CA', { weekday: 'long', month: 'short', day: 'numeric' })} · ${d.t_min}–${d.t_max}°C · ${d.precip_prob}% precip (${d.precip_mm}mm)${d.snow_cm ? ` · ${d.snow_cm}cm snow` : ''}${d.risk !== 'none' ? ' — watch concrete pours & roofing' : ''}`}
          className={`flex flex-col items-center rounded-lg px-1.5 py-0.5 flex-shrink-0 border ${
            d.risk === 'high' ? 'bg-red-50 border-red-200' : d.risk === 'caution' ? 'bg-amber-50 border-amber-200' : 'border-transparent'
          }`}
        >
          <span className="text-[8px] font-bold text-gray-400 leading-none">
            {new Date(d.date + 'T12:00:00').toLocaleDateString('en-CA', { weekday: 'short' })} {new Date(d.date + 'T12:00:00').getDate()}
          </span>
          <span className="flex items-center gap-0.5">
            <span className={`material-symbols-outlined text-sm leading-none ${d.risk === 'high' ? 'text-red-500' : d.risk === 'caution' ? 'text-amber-500' : 'text-gray-400'}`}>
              {weatherIcon(d.code)}
            </span>
            <span className="text-[10px] font-bold text-gray-700">{d.t_max}°</span>
            {d.precip_prob >= 30 && <span className="text-[8px] font-semibold text-blue-500">{d.precip_prob}%</span>}
          </span>
        </div>
      ))}
    </div>
  );
}
